(function () {
  var WRAPPER_SELECTOR = '.hero__pendant';
  var VIDEO_SELECTOR = '.hero__pendant-media--alpha';
  var WHITE_THRESHOLD = 240;
  var SOFT_RANGE = 20;

  function isSafari() {
    var ua = navigator.userAgent;
    return /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS/i.test(ua);
  }

  function supportsWebmAlpha() {
    var video = document.createElement('video');
    return video.canPlayType('video/webm; codecs="vp9"') !== '';
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function showFallback(wrapper) {
    wrapper.classList.add('hero__pendant--show-fallback');
  }

  function ensurePlayback(video) {
    if (prefersReducedMotion() || !video) return;

    var playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(function () {
        var resume = function () {
          video.play().catch(function () {});
        };

        document.addEventListener('touchstart', resume, { once: true, passive: true });
        document.addEventListener('click', resume, { once: true });
      });
    }
  }

  function needsCanvasFallback() {
    if (prefersReducedMotion()) return false;
    return isSafari() || !supportsWebmAlpha();
  }

  function initCanvasFallback(wrapper, video) {
    var canvas = document.createElement('canvas');
    canvas.className = 'hero__pendant-media hero__pendant-media--canvas';
    canvas.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(canvas);

    var context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) {
      showFallback(wrapper);
      return;
    }

    video.style.display = 'none';

    var drawing = false;
    var failureTimer = window.setTimeout(function () {
      if (!video.videoWidth) showFallback(wrapper);
    }, 5000);

    function clearFailureTimer() {
      window.clearTimeout(failureTimer);
    }

    function resizeCanvas() {
      var width = video.videoWidth;
      var height = video.videoHeight;
      if (!width || !height) return;

      canvas.width = width;
      canvas.height = height;
    }

    function drawFrame() {
      if (!video.videoWidth || !video.videoHeight) return;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      var pixels = imageData.data;

      for (var i = 0; i < pixels.length; i += 4) {
        var red = pixels[i];
        var green = pixels[i + 1];
        var blue = pixels[i + 2];
        var brightest = Math.max(red, green, blue);

        if (brightest >= WHITE_THRESHOLD) {
          pixels[i + 3] = 0;
        } else if (brightest >= WHITE_THRESHOLD - SOFT_RANGE) {
          var fade = (WHITE_THRESHOLD - brightest) / SOFT_RANGE;
          pixels[i + 3] = Math.round(pixels[i + 3] * fade);
        }
      }

      context.putImageData(imageData, 0, 0);
    }

    function tick() {
      if (video.paused || video.ended) return;
      drawFrame();
      drawing = true;
      requestAnimationFrame(tick);
    }

    function start() {
      clearFailureTimer();
      resizeCanvas();
      if (!drawing) tick();
    }

    video.addEventListener('loadeddata', start);
    video.addEventListener('play', start);
    video.addEventListener('loadedmetadata', resizeCanvas);
    video.addEventListener('error', function () {
      clearFailureTimer();
      showFallback(wrapper);
    });

    ensurePlayback(video);

    if (video.readyState >= 2) start();
  }

  function initNativeVideo(wrapper, video) {
    ensurePlayback(video);

    video.addEventListener('error', function () {
      showFallback(wrapper);
    });

    window.setTimeout(function () {
      if (video.paused && !video.error) ensurePlayback(video);
    }, 500);
  }

  function initPendant(wrapper) {
    var video = wrapper.querySelector(VIDEO_SELECTOR);
    if (!video) return;

    if (prefersReducedMotion()) {
      showFallback(wrapper);
      return;
    }

    if (needsCanvasFallback()) {
      initCanvasFallback(wrapper, video);
    } else {
      initNativeVideo(wrapper, video);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) ensurePlayback(video);
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(wrapper);
    }
  }

  function init() {
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(initPendant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
